// extracted by mini-css-extract-plugin
export default {"container":"GlobalNavigation_container__MmEyN"};